import { render, staticRenderFns } from "./left-right-layout.vue?vue&type=template&id=63949230"
import script from "./left-right-layout.vue?vue&type=script&lang=js"
export * from "./left-right-layout.vue?vue&type=script&lang=js"
import style0 from "./left-right-layout.vue?vue&type=style&index=0&id=63949230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports